import {
  addCoupon,
  addItemToCart,
  addPackageItemToCart,
  addSeatItemToCart,
  applyHandleToCart,
  checkoutCart,
  getCart,
  getCartOptions,
  modifyItemInCart,
  modifySeatVariantInCart,
  PackageVariantsMap,
  PaymentInformation,
  removeItemFromCart,
  removeSeatItemFromCart,
  ShippingInformation,
  updateCartPaymentInformation as updatePaymentInformation,
  updateCartShippingInformation as updateShippingInformation,
  updateRepliesForCartItem,
  createPayPalOrder as createPayPalOrderForCart,
} from '@ttstr/api/cart';

import { CatalogFormReplies, Variant, Product } from '@ttstr/api';
import { ThunkActionCreator } from '.';
import { trackAddToCartEvent } from '@ttstr/utils';

export const CART_LOADING = 'CART.CART_LOADING';
export const CART_LOADED = 'CART.CART_LOADED';
export const CART_LOADING_FAILED = 'CART.CART_LOADING_FAILED';

export const CART_ITEM_ADDING = 'CART.CART_ITEM_ADDING';
export const CART_ITEM_ADDED = 'CART.CART_ITEM_ADDED';
export const CART_ITEM_ADDING_FAILED = 'CART.CART_ITEM_ADDING_FAILED';
export const CART_ITEM_ADDING_DONE = 'CART.CART_ITEM_ADDING_DONE';

export const CART_ITEM_MODIFYING = 'CART.CART_ITEM_MODIFYING';
export const CART_ITEM_MODIFIED = 'CART.CART_ITEM_MODIFIED';
export const CART_ITEM_MODIFYING_FAILED = 'CART.CART_ITEM_MODIFYING_FAILED';

export const CART_ITEM_REMOVING = 'CART.CART_ITEM_REMOVING';
export const CART_ITEM_REMOVED = 'CART.CART_ITEM_REMOVED';
export const CART_ITEM_REMOVING_FAILED = 'CART.CART_ITEM_REMOVING_FAILED';

export const CART_ITEM_SEAT_ADDING = 'CART.CART_ITEM_SEAT_ADDING';
export const CART_ITEM_SEAT_ADDED = 'CART.CART_ITEM_SEAT_ADDED';
export const CART_ITEM_SEAT_ADDING_FAILED = 'CART.CART_ITEM_SEAT_ADDING_FAILED';
export const CART_ITEM_SEAT_ADDING_DONE = 'CART.CART_ITEM_SEAT_ADDING_DONE';

export const CART_ITEM_SEAT_CHANGING_VARIANT = 'CART.CART_ITEM_SEAT_CHANGING_VARIANT';
export const CART_ITEM_SEAT_CHANGED_VARIANT = 'CART.CART_ITEM_SEAT_CHANGED_VARIANT';
export const CART_ITEM_SEAT_CHANGE_VARIANT_FAILED = 'CART_ITEM_SEAT_CHANGE_VARIANT_FAILED';
export const CART_ITEM_SEAT_CHANGE_VARIANT_DONE = 'CART_ITEM_SEAT_CHANGE_VARIANT_DONE';

export const CART_ITEM_SEAT_REMOVING = 'CART.CART_ITEM_SEAT_REMOVING';
export const CART_ITEM_SEAT_REMOVED = 'CART.CART_ITEM_SEAT_REMOVED';
export const CART_ITEM_SEAT_REMOVING_FAILED = 'CART.CART_ITEM_SEAT_REMOVING_FAILED';
export const CART_ITEM_SEAT_REMOVING_DONE = 'CART.CART_ITEM_SEAT_REMOVING_DONE';

export const CART_SHIPPING_INFORMATION_UPDATING = 'CART.CART_SHIPPING_INFORMATION_UPDATING';
export const CART_SHIPPING_INFORMATION_UPDATED = 'CART.CART_SHIPPING_INFORMATION_UPDATED';
export const CART_SHIPPING_INFORMATION_UPDATING_FAILED = 'CART.CART_SHIPPING_INFORMATION_UPDATING_FAILED';

export const CART_PAYMENT_INFORMATION_UPDATING = 'CART.CART_PAYMENT_INFORMATION_UPDATING';
export const CART_PAYMENT_INFORMATION_UPDATED = 'CART.CART_PAYMENT_INFORMATION_UPDATED';
export const CART_PAYMENT_INFORMATION_UPDATING_FAILED = 'CART.CART_PAYMENT_INFORMATION_UPDATING_FAILED';

export const CART_CHECKOUT_REQUESTED = 'CART.CART_CHECKOUT_REQUESTED';
export const CART_CHECKOUT_SUCCEEDED = 'CART.CART_CHECKOUT_SUCCEEDED';
export const CART_CHECKOUT_FAILED = 'CART.CART_CHECKOUT_FAILED';
export const CART_CHECKOUT_DONE = 'CART.CART_CHECKOUT_DONE';

export const CART_ADD_COUPON_REQUESTED = 'CART.CART_ADD_COUPON_REQUESTED';
export const CART_ADD_COUPON_SUCCEEDED = 'CART.CART_ADD_COUPON_SUCCEEDED';
export const CART_ADD_COUPON_FAILED = 'CART.CART_ADD_COUPON_FAILED';
export const CART_ADD_COUPON_DONE = 'CART.CART_ADD_COUPON_DONE';

export const UPDATE_EXPIRATION = 'CART.UPDATE_EXPIRATION';
export const SHOW_FINISHER = 'CART.SHOW_FINISHER';
export const HIDE_FINISHER = 'CART.HIDE_FINISHER';

export const CART_OPTIONS_REQUESTED = 'CART.CART_OPTIONS_REQUESTED';
export const CART_OPTIONS_SUCCEEDED = 'CART.CART_OPTIONS_SUCCEEDED';
export const CART_OPTIONS_FAILED = 'CART.CART_OPTIONS_FAILED';
export const CART_OPTIONS_DONE = 'CART.CART_OPTIONS_DONE';

export const CART_ITEM_REPLIES_UPDATING = 'CART.CART_ITEM_REPLIES_UPDATING';
export const CART_ITEM_REPLIES_UPDATED = 'CART.CART_ITEM_REPLIES_UPDATED';
export const CART_ITEM_REPLIES_UPDATING_FAILED = 'CART.CART_ITEM_REPLIES_UPDATING_FAILED';
export const CART_ITEM_REPLIES_UPDATING_DONE = 'CART.CART_ITEM_REPLIES_UPDATING_DONE';

export const CART_NULLIFY = 'CART.NULLIFY';

// export const CART_PAY_PAL_ORDER_CREATING = 'CART.PAY_PAL_ORDER_CREATING';
// export const CART_PAY_PAL_ORDER_CREATED = 'CART.PAY_PAL_ORDER_CREATED';
// export const CART_PAY_PAL_ORDER_CREATION_FAILED = 'CART.PAY_PAL_ORDER_CREATION_FAILED';

export const nullifyCart: ThunkActionCreator = () => async (dispatch) => {
  dispatch(stopCartPolling());
  dispatch({
    type: CART_NULLIFY,
    payload: {
      cart: null,
    },
  });
};

export const loadCart: ThunkActionCreator = () => async (dispatch) => {
  try {
    dispatch({ type: CART_LOADING });
    const cart = await getCart();
    dispatch({
      type: CART_LOADED,
      payload: {
        cart,
      },
    });
    dispatch(registerTimer());
    return cart;
  } catch (error) {
    dispatch({
      type: CART_LOADING_FAILED,
      payload: {
        error,
      },
    });
  }
};

export const addToCart: ThunkActionCreator = (variantId: number, quantity: number, variant?: Variant, product?: Product) => async (dispatch) => {
  dispatch({ type: CART_ITEM_ADDING });
  try {
    const updatedCart = await addItemToCart(variantId, quantity);
    dispatch({
      type: CART_ITEM_ADDED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
    dispatch(showFinisher());
    trackAddToCartEvent(variant, quantity || 1, product);
  } catch (error) {
    dispatch({
      type: CART_ITEM_ADDING_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CART_ITEM_ADDING_DONE,
    });
  }
};

export const addPackageToCart: ThunkActionCreator = (
  variantId: number,
  quantity: number,
  variants_map: PackageVariantsMap,
  variant?: Variant,
  product?: Product
) => async (dispatch) => {
  dispatch({ type: CART_ITEM_ADDING });
  try {
    const updatedCart = await addPackageItemToCart(variantId, quantity, variants_map);
    dispatch({
      type: CART_ITEM_ADDED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
    dispatch(showFinisher());
    trackAddToCartEvent(variant, quantity, product);
  } catch (error) {
    dispatch({
      type: CART_ITEM_ADDING_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  }
};

export const requestApplyHandleToCart: ThunkActionCreator = (password: string, variantId: number) => async (
  dispatch
) => {
  dispatch({ type: CART_ITEM_ADDING });
  try {
    const updatedCart = await applyHandleToCart(password, variantId);
    dispatch({
      type: CART_ITEM_ADDED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
    dispatch(showFinisher());
  } catch (error) {
    dispatch({
      type: CART_ITEM_ADDING_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  }
};

export const showFinisher: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: SHOW_FINISHER,
  });
};

export const hideFinisher: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: HIDE_FINISHER,
  });
};

export const modifyQuantityInCart: ThunkActionCreator = (cartItemId: number, quantity: number, variant?: Variant, added?: number) => async (dispatch) => {
  dispatch({ type: CART_ITEM_MODIFYING });
  try {
    const updatedCart = await modifyItemInCart(cartItemId, quantity);
    dispatch({
      type: CART_ITEM_MODIFIED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
    trackAddToCartEvent(variant, added);
  } catch (error) {
    dispatch({
      type: CART_ITEM_MODIFYING_FAILED,
      payload: {
        error,
      },
    });
  }
};

export const modifyVariantInCart: ThunkActionCreator = (cartItemId: number, seats: any[]) => async (dispatch) => {
  dispatch({ type: CART_ITEM_MODIFYING });
  try {
    const updatedCart = await modifySeatVariantInCart(cartItemId, seats);
    dispatch({
      type: CART_ITEM_MODIFIED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
  } catch (error) {
    dispatch({
      type: CART_ITEM_MODIFYING_FAILED,
      payload: {
        error,
      },
    });
  }
};

export const removeFromCart: ThunkActionCreator = (cartItemId: number) => async (dispatch) => {
  dispatch({ type: CART_ITEM_REMOVING });
  try {
    const updatedCart = await removeItemFromCart(cartItemId);
    dispatch({
      type: CART_ITEM_REMOVED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in) dispatch(registerTimer());
  } catch (error) {
    dispatch({
      type: CART_ITEM_REMOVING_FAILED,
      payload: {
        error,
      },
    });
  }
};

export const addSeatToCart: ThunkActionCreator = (seatId: number, variant?: Variant, product?: Product) => async (
  dispatch
) => {
  dispatch({
    type: CART_ITEM_SEAT_ADDING,
    payload: {
      seatId,
    },
  });
  try {
    const updatedCart = await addSeatItemToCart(seatId);
    dispatch({
      type: CART_ITEM_SEAT_ADDED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
    // dispatch(showFinisher());
    trackAddToCartEvent(variant, 1, product);
  } catch (error) {
    dispatch({
      type: CART_ITEM_SEAT_ADDING_FAILED,
      payload: {
        error,
        seatId,
      },
    });
  } finally {
    dispatch({
      type: CART_ITEM_SEAT_ADDING_DONE,
      payload: {
        seatId,
      },
    });
  }
};

export const removeSeatFromCart: ThunkActionCreator = (seatId: number) => async (dispatch) => {
  dispatch({
    type: CART_ITEM_SEAT_REMOVING,
    payload: {
      seatId,
    },
  });
  try {
    const updatedCart = await removeSeatItemFromCart(seatId);
    dispatch({
      type: CART_ITEM_SEAT_REMOVED,
      payload: {
        cart: updatedCart,
      },
    });
    if (updatedCart.expires_in > 0) dispatch(registerTimer());
  } catch (error) {
    dispatch({
      type: CART_ITEM_SEAT_REMOVING_FAILED,
      payload: {
        error,
        seatId,
      },
    });
  } finally {
    dispatch({
      type: CART_ITEM_SEAT_REMOVING_DONE,
      payload: {
        seatId,
      },
    });
  }
};

// export const modifySeatVariant: ThunkActionCreator = (seats: CartSeat[]) => async (dispatch) => {
//   dispatch({
//     type: CART_ITEM_SEAT_CHANGING_VARIANT,
//     payload: {
//       seats,
//     },
//   });
//   try {
//     const updatedCart = await modifySeatVariantInCart(seats);
//     dispatch({
//       type: CART_ITEM_SEAT_CHANGED_VARIANT,
//       payload: {
//         cart: updatedCart,
//       },
//     });
//     if (updatedCart.expires_in > 0) dispatch(registerTimer());
//   } catch (error) {
//     dispatch({
//       type: CART_ITEM_SEAT_CHANGE_VARIANT_FAILED,
//       payload: {
//         error,
//         seats,
//       },
//     });
//   } finally {
//     dispatch({
//       type: CART_ITEM_SEAT_CHANGE_VARIANT_DONE,
//       payload: {
//         seats,
//       },
//     });
//   }
// };

export const updateCartShippingInformation: ThunkActionCreator = (
  shippingInformation: ShippingInformation,
  signal?: AbortSignal
) => async (dispatch) => {
  dispatch({ type: CART_SHIPPING_INFORMATION_UPDATING });
  try {
    const updatedCart = await updateShippingInformation(shippingInformation, { signal });
    dispatch({
      type: CART_SHIPPING_INFORMATION_UPDATED,
      payload: {
        cart: updatedCart,
      },
    });
    dispatch(registerTimer());
  } catch (error) {
    dispatch({
      type: CART_SHIPPING_INFORMATION_UPDATING_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  }
};

export const updateCartPaymentInformation: ThunkActionCreator = (paymentInformation: PaymentInformation) => async (
  dispatch
) => {
  dispatch({ type: CART_PAYMENT_INFORMATION_UPDATING });
  try {
    const updatedCart = await updatePaymentInformation(paymentInformation);
    dispatch({
      type: CART_PAYMENT_INFORMATION_UPDATED,
      payload: {
        cart: updatedCart,
      },
    });
    return updatedCart;
  } catch (error) {
    dispatch({
      type: CART_PAYMENT_INFORMATION_UPDATING_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  }
};

export const updateCartItemReplies: ThunkActionCreator = (cartItemId: number, replies: CatalogFormReplies) => async (
  dispatch
) => {
  dispatch({ type: CART_ITEM_REPLIES_UPDATING });
  try {
    const updatedCart = await updateRepliesForCartItem(cartItemId, replies);
    dispatch({
      type: CART_ITEM_REPLIES_UPDATED,
      payload: {
        cart: updatedCart,
      },
    });
    return updatedCart;
  } catch (error) {
    dispatch({
      type: CART_ITEM_REPLIES_UPDATING_FAILED,
      payload: {
        cartItemId,
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CART_ITEM_REPLIES_UPDATING_DONE,
      payload: {
        cartItemId,
      },
    });
  }
};

export const requestAddCoupon: ThunkActionCreator = (token: string) => async (dispatch) => {
  dispatch({
    type: CART_ADD_COUPON_REQUESTED,
  });

  try {
    const cart = await addCoupon(token);

    dispatch({
      type: CART_ADD_COUPON_SUCCEEDED,
      payload: {
        cart,
      },
    });

    if (cart.expires_in > 0) dispatch(registerTimer());
  } catch (error) {
    dispatch({
      type: CART_ADD_COUPON_FAILED,
      payload: {
        error,
      },
    });
    throw error;
  } finally {
    dispatch({
      type: CART_ADD_COUPON_DONE,
    });
  }
};

export const checkout: ThunkActionCreator = (allowPromotion: boolean) => async (dispatch, getState) => {
  dispatch({
    type: CART_CHECKOUT_REQUESTED,
  });

  try {
    const checkoutStatus = await checkoutCart(allowPromotion);

    dispatch({
      type: CART_CHECKOUT_SUCCEEDED,
    });

    let { cart_token } = checkoutStatus;
    if (!cart_token) {
      await dispatch(loadCart());
      ({ cart_token } = getState().Cart.cart);
    }

    return cart_token;
  } catch (error) {
    dispatch({
      type: CART_CHECKOUT_FAILED,
    });
    throw error;
  } finally {
    dispatch({
      type: CART_CHECKOUT_DONE,
    });
  }
};

export const receiveCartOptions: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: CART_OPTIONS_REQUESTED,
  });
  try {
    const articles = await getCartOptions();

    dispatch({
      type: CART_OPTIONS_SUCCEEDED,
      payload: {
        articles,
      },
    });
    return articles;
  } catch (error) {
    dispatch({
      type: CART_OPTIONS_FAILED,
    });
  } finally {
    dispatch({
      type: CART_OPTIONS_DONE,
    });
  }
};

let timerId: NodeJS.Timeout;
const REFRESH_AFTER_STEPS = 10;
const INTERVAL = 10000;

export const registerTimer: ThunkActionCreator = () => async (dispatch, getState) => {
  let step = 1;
  dispatch(stopCartPolling());
  const loop = () => {
    const { expiresIn, cart } = getState().Cart;
    const REFRESH_AFTER_MS = INTERVAL * REFRESH_AFTER_STEPS;
    const SCHEDULED_NEXT_RELOAD =
      cart.expires_in !== null ? Math.min(cart.expires_in * 1000, REFRESH_AFTER_MS) : REFRESH_AFTER_MS;
    if (INTERVAL * step++ > SCHEDULED_NEXT_RELOAD || (expiresIn !== null && expiresIn <= 0)) {
      step = 1;
      return dispatch(loadCart());
    }

    dispatch({ type: UPDATE_EXPIRATION });
    timerId = setTimeout(loop, INTERVAL);
  };

  loop();
};

export const stopCartPolling: ThunkActionCreator = () => async () => {
  clearTimeout(timerId);
};
